class Monitoring.Models.GenericRule extends Backbone.Model
  urlRoot: '/monitoring/generic_rules'

  defaults: ->
    name: ''
    description: ''
    active: true
    start_date: undefined
    end_date: null
    social_content_condition: @socialContentConditionsDefaults()
    actions: @actionsDefaults()

  socialContentConditionsDefaults: ->
    topics: []
    tags: []
    no_other_tags: false
    groups: []
    sentiments: []
    subtypes: []
    ownership: 'all-content'
    authors: []
    excluded_authors: []
    moderation_statuses: []
    locations: []
    mentions: [],
    keywords: {},
    min_followers: null
    news_sources: []
    intelligent_filter: @_emptyIntelligentFilter()

  actionsDefaults: ->
    []

  validateFields: ->
    min_followers = @get('social_content_condition').min_followers
    unless min_followers == null or min_followers == '' or (min_followers + "").match(/^\d+$/)
      return I18n.t('monitoring.rules.validations.invalid_followers')
    @validateLengthOfStrings()

  validateLengthOfStrings: ->
    stringFields = [
      'topics',
      'tags',
      'groups',
      'subtypes',
      'authors',
      'excluded_authors',
      'mentions',
      'news_sources',
      'locations'
    ]

    ret = "VALID"

    _.each(stringFields, (field) =>
      string = @get('social_content_condition')[field].join(', ')
      if string.length > 2000
        translationKey = "monitoring.arrival_alerts.fields.#{field}"
        ret = "#{I18n.t('monitoring.arrival_alerts.validations.too_many')} #{I18n.t(translationKey)}!"
    )

    return ret

  isEmail: (string) ->
    string.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)

  getTopicIdsAsIntegers: ->
    _.map(@get('social_content_condition').topics, (id) -> parseInt(id))

  getFormattedStartDate: (format = 'YYYY-MM-DD') ->
    return '' unless @get('start_date')
    Date.create(@get('start_date')).format(format)

  getFormattedEndDate: (format = 'YYYY-MM-DD') ->
    return '' unless @get('end_date')
    Date.create(@get('end_date')).format(format)

  getFormattedUpdatedAt: (format = 'YYYY-MM-DD') ->
    return '' unless @get('updated_at')
    Date.create(@get('updated_at')).format(format)

  _emptyIntelligentFilter: ->
    {
      intelligent_tags: {
        main_tags: [],
        secondary_tags: [],
        excluded_tags: [],
        main_tags_logic: 'OR',
        secondary_tags_logic: 'OR',
        excluded_tags_logic: 'OR'
      },
      intelligent_groups: {
        main_groups: [],
        secondary_groups: [],
        excluded_groups: [],
        main_groups_logic: 'OR',
        secondary_groups_logic: 'OR',
        excluded_groups_logic: 'OR'
      }
    }

class Monitoring.Collections.GenericRulesCollection extends Backbone.Collection
  model: Monitoring.Models.GenericRule
